const doctorGalleryImages = () =>
    import ( /* webpackChunkName: "Gallery" */ "@/components/dashboard/doctor/GalleryImages");
const doctorGalleryAudios = () =>
    import ( /* webpackChunkName: "General" */ "@/components/dashboard/doctor/ComingSoon");
const doctorGalleryVideos = () =>
    import ( /* webpackChunkName: "General" */ "@/components/dashboard/doctor/ComingSoon");
const doctorGalleryPDFs = () =>
    import ( /* webpackChunkName: "Gallery" */ "@/components/dashboard/doctor/GalleryPdf");

export default [{
        path: "images",
        name: "dashboard.allied.gallery.images",
        component: doctorGalleryImages
    },
    {
        path: "audios",
        name: "dashboard.allied.gallery.audios",
        component: doctorGalleryAudios
    },
    {
        path: "videos",
        name: "dashboard.allied.gallery.videos",
        component: doctorGalleryVideos
    },
    {
        path: "pdf",
        name: "dashboard.allied.gallery.pdfs",
        component: doctorGalleryPDFs
    }
];